<template>
  <iframe
      :src="url"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      @load="load"
  ></iframe>
</template>

<script>
export default {
  name: 'h-iframe',
  data(){
    return{
      url:'',
    }
  },
  mounted() {
    this.url = this.$route.query.url
  },
  methods:{
    load(){
      this.$store.commit('setLoading', false);
    }
  },
  watch:{
    '$route.query.url'(newValue, oldValue) {
      if(newValue){
        this.$store.commit('setLoading', true);
        this.url = newValue;
      }
    },
  }
}
</script>

<style scoped>

</style>
